// extracted by mini-css-extract-plugin
module.exports = {"updatesPointer":"TimelineUpdatesCount_updatesPointer__s1wxr","timelineUpdatesCount":"TimelineUpdatesCount_timelineUpdatesCount__g27z_"};